document.addEventListener('DOMContentLoaded', function () {
  var watchedDropdowns = new WeakSet();

  function getSectionId() {
    var info = document.querySelector('product-info[id^="ProductInfo-"]');
    if (!info) {
      console.warn('[kaching-sync] Nie znaleziono <product-info>');
      return null;
    }
    return info.dataset.section;
  }

  function getColorMediaMap(sectionId) {
    var el = document.getElementById('ColorMediaMap-' + sectionId);
    if (!el) {
      console.warn('[kaching-sync] Nie znaleziono #ColorMediaMap-' + sectionId + ' w HTML');
      return null;
    }
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      console.warn('[kaching-sync] Błąd parsowania ColorMediaMap', e);
      return null;
    }
  }

  function updateMainImageForColor(colorName) {
    console.log('[kaching-sync] Próba zmiany zdjęcia dla koloru:', colorName);

    var sectionId = getSectionId();
    if (!sectionId || !colorName) return;

    var map = getColorMediaMap(sectionId);
    if (!map) return;

    var normalized = colorName.trim().toLowerCase();
    var mediaId = null;
    Object.keys(map).forEach(function (key) {
      if (key.trim().toLowerCase() === normalized) {
        mediaId = map[key];
      }
    });

    if (!mediaId) {
      console.warn('[kaching-sync] Nie znaleziono media dla koloru "' + colorName + '". Dostępne kolory:', Object.keys(map));
      return;
    }

    var gallery = document.querySelector('[id^="MediaGallery-' + sectionId + '"]');
    if (!gallery) {
      console.warn('[kaching-sync] Nie znaleziono <media-gallery> o id zawierającym MediaGallery-' + sectionId);
      return;
    }
    if (typeof gallery.setActiveMedia !== 'function') {
      console.warn('[kaching-sync] media-gallery nie ma metody setActiveMedia');
      return;
    }

    console.log('[kaching-sync] OK -> ustawiam media id:', sectionId + '-' + mediaId);
    gallery.setActiveMedia(sectionId + '-' + mediaId, true);
  }

  function watchDropdown(dropdown) {
    if (watchedDropdowns.has(dropdown)) return;
    watchedDropdowns.add(dropdown);

    console.log('[kaching-sync] Znaleziono nowy dropdown, aktualna wartość:', dropdown.getAttribute('data-value'));
    updateMainImageForColor(dropdown.getAttribute('data-value'));

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.attributeName === 'data-value') {
          updateMainImageForColor(dropdown.getAttribute('data-value'));
        }
      });
    });
    observer.observe(dropdown, { attributes: true });
  }

  function scanForDropdowns() {
    document
      .querySelectorAll('.kaching-bundles__swatch-dropdown[data-name="Kolor"]')
      .forEach(watchDropdown);
  }

  console.log('[kaching-sync] Skrypt wystartował (v5 - ColorMediaMap z Liquid)');
  scanForDropdowns();

  var bodyObserver = new MutationObserver(scanForDropdowns);
  bodyObserver.observe(document.body, { childList: true, subtree: true });
});